export default __webpack_public_path__ + "static/PEPESTREET-b2bbffb29992987ab311ed581b031e3a.jpg";